// extracted by mini-css-extract-plugin
module.exports = {"__select":"CustomSelect___select__kl__A","selectActive":"CustomSelect_selectActive__bw7UQ"};